import { render, staticRenderFns } from "./SeminarAddress.vue?vue&type=template&id=df0faff2&"
import script from "./SeminarAddress.vue?vue&type=script&lang=js&"
export * from "./SeminarAddress.vue?vue&type=script&lang=js&"
import style0 from "./SeminarAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports